import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/utils';
import { KeyBadge } from './key-badge';

/** Dock do modo Palco: controles + Anterior à esquerda e "Próxima · tom" (botão branco) à direita. */
export const StageDock: React.FC<{
  children: React.ReactNode;
  hasPrevious: boolean;
  hasNext: boolean;
  nextTitle?: string;
  nextKey?: string;
  onPrevious: () => void;
  onNext: () => void;
  className?: string;
}> = ({
  children,
  hasPrevious,
  hasNext,
  nextTitle,
  nextKey,
  onPrevious,
  onNext,
  className,
}) => (
  <div
    className={cn(
      'fixed inset-x-0 bottom-0 z-30 flex items-center gap-3 border-border border-t bg-background/95 px-4 py-3 backdrop-blur print:hidden',
      className,
    )}
  >
    <button
      type="button"
      onClick={onPrevious}
      disabled={!hasPrevious}
      className="flex h-11 shrink-0 items-center gap-2 rounded-[12px] border border-border-strong px-4 font-semibold text-[13px] text-white hover:bg-raised disabled:opacity-30"
    >
      <Icon name="chevron-left" className="size-4" />
      Anterior
    </button>

    <div className="min-w-0 flex-1 overflow-x-auto">{children}</div>

    <button
      type="button"
      onClick={onNext}
      disabled={!hasNext}
      title={nextTitle}
      className="flex h-11 shrink-0 items-center gap-2 rounded-[12px] bg-white px-4 font-semibold text-[13px] text-black hover:bg-white/90 disabled:opacity-30"
    >
      Próxima
      {nextKey && (
        <KeyBadge value={nextKey} className="h-5 bg-black/10 text-black ring-0" />
      )}
      <Icon name="chevron-right" className="size-4" />
    </button>
  </div>
);
